import axios from 'axios';

import { reportIfPausedWorkspaceResponse } from '@/pages/workgroup/autoPause/pausedWorkspaceDetection';

const axiosController = axios.create({
  baseURL: import.meta.env.VITE_CONTROLLER_URL,
});

const axiosOrgService = axios.create({
  baseURL: import.meta.env.VITE_ORG_URL,
});

const axiosCluster = axios.create({});

axiosCluster.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 400) {
      localStorage.removeItem('instanceLoginFailed');
    }
    // A paused workspace is answered by the auto-start handler with 202, which axios resolves as a
    // success. Detecting it here rather than in the error handler is what makes it visible at all.
    reportIfPausedWorkspaceResponse(response.status, response.data);
    return response;
  },
  (error) => {
    if (error?.response) {
      reportIfPausedWorkspaceResponse(error.response.status, error.response.data);
    }
    return Promise.reject(error);
  }
);

export { axiosController, axiosOrgService, axiosCluster };
